import { dateFormatter } from "@/utils/dateFormatter";

import type { CompletedRequest, TableConfig } from "../../../types/tables";

import {
  brandCell,
  createdByCell,
  nameCell,
  requestDesignTypeCell,
  statusCell,
} from "../../helpers/commonCells";
import { renderRating } from "../../helpers/renderHelpers";

// Completed Tab Configuration
export const completedTableConfig: TableConfig<CompletedRequest> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: 250,
    },
    {
      accessor: "brand",
      cellRenderer: brandCell,
      header: "Brand",
      key: "brand",
      sortable: true,
      width: 200,
    },
    {
      accessor: "completedDate",
      cellRenderer: (value: unknown) => {
        if (!value || typeof value !== "string") {
          return <span className="text-text-tertiary">--</span>;
        }

        return <span className="text-sm">{dateFormatter(value)}</span>;
      },
      header: "Completed date",
      key: "completedDate",
      sortable: true,
      width: 150,
    },
    {
      accessor: "createdBy",
      cellRenderer: createdByCell,
      header: "Created by",
      key: "createdBy",
      sortable: true,
      width: 140,
    },
    {
      accessor: "status",
      cellRenderer: statusCell,
      header: "Status",
      key: "status",
      sortable: false,
      width: 150,
    },
    {
      accessor: "rating",
      cellRenderer: (value: unknown) =>
        renderRating(value as null | number | undefined),
      header: "Rating",
      key: "rating",
      sortable: true,
      width: 120,
    },
    {
      accessor: "requestType",
      cellRenderer: requestDesignTypeCell,
      header: "Request/Design type",
      key: "requestType",
      sortable: true,
      width: 180,
    },
  ],
  defaultSort: {
    column: "completedDate",
    direction: "desc",
  },
  enableSorting: true,
  id: "completed-requests",
  title: "Completed Requests",
};
